import { flatten, ParamValue } from './QueryString';
import { IFilter } from './ISearchService';
import { msiInfo } from './MsiInfo';

export interface IFacet {
	column: string;
	query: string;
	label: string;
	createFilter (param: ParamValue): IFilter;
	getTitle (value: string): string;
	helpName: string | undefined;
}

export class EqualityFacet implements IFacet {
	public createFilter (param: ParamValue): IFilter {
		const value = flatten(param);
		const escapedValue = value.replace(/'/g, '\'\'');

		const expression = `${this.column} eq '${escapedValue}'`;

		return { key: this.column, value, label: value, expression, removable: true };
	}

	getTitle = (value: string): string => value;

	constructor (public column: string, public query: string, public label: string, public helpName: string | undefined) {

	}
}

export class PeriodFacet implements IFacet {
	public createFilter (param: ParamValue): IFilter {
		const value = flatten(param);
		const escapedValue = value.replace(/'/g, '\'\'');

		const expression = `${this.column} eq '${escapedValue}'`;

		return { key: this.column, value, label: value, expression, removable: false };
	}

	getTitle = (value: string): string => value;

	constructor (public column: string, public query: string, public label: string, public helpName: string | undefined) {

	}
}

export class MsiFacet implements IFacet {
	public createFilter (param: ParamValue): IFilter {
		const value = flatten(param);
		const escapedValue = value.replace(/'/g, '\'\'');

		const expression = `${this.column}/any(c: c eq '${escapedValue}')`;

		const label = msiInfo.getMetadata(value).title;

		return { key: this.column, value, label, expression, removable: true };
	}

	getTitle = (value: string): string => msiInfo.getMetadata(value).title;

	constructor (public column: string, public query: string, public label: string, public helpName: string | undefined) {

	}
}

export class IdListFacet implements IFacet {
	public createFilter (param: ParamValue): IFilter {
		const value = flatten(param);

		const expression = `search.in(id,'${value}')`;

		return { key: this.column, value, label: this.label, expression, removable: true };
	}

	getTitle = (value: string): string => value;

	constructor (public column: string, public query: string, public label: string) {

	}

	helpName: string | undefined = undefined;
}
